import { reactive } from 'vue'

export const languageStore = reactive({
  currentLanguage: 'en',
  
  setLanguage(lang) {
    this.currentLanguage = lang
  },
  
  getLanguage() {
    return this.currentLanguage
  }
})
